module.exports = __webpack_public_path__ + "static/media/POS_02_B.67897c6c.png";